import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from '@material-ui/core';
import { defaultSliderOptions } from './constants';
import './styles.scss';
import { noop } from '../propTypes';

function CustomSlider({ marks, handleChange }) {
    return (
        <Slider
            aria-label="custom thumb label"
            step={null}
            marks={marks}
            defaultValue={1}
            onChange={(event, value) => {
                Object.keys(event);
                handleChange(value);
            }}
        />
    );
}

CustomSlider.propTypes = {
    marks: PropTypes.array,
    handleChange: PropTypes.func,
};

CustomSlider.defaultProps = {
    marks: defaultSliderOptions,
    handleChange: noop,
};

export default CustomSlider;
